import React, { useEffect, useState } from 'react'
import { Button, Form } from 'react-bootstrap'
import ModalCustom from '../../modal-custom'
import { Controller, useForm } from 'react-hook-form'
import DatepickerCustom from '../../datepicker-custom'
import SwalCustom from '../../../alert/swal-custom'
import moment from 'moment'
import { createEjipFundAPI } from '../../../services/ejip'
import Error_false from '../../error/error-false'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { TXTSUCCESS } from '../../../Constants'
import CustomDatePicker from '../../custom/CustomDatePicker'
// import CustomDatePicker from '../../datepicker-custiom-lock'

const schema = yup
  .object({
    fundName: yup.string().required('This is a required question'),
    openDate: yup.string().required('This is a required question'),
    endDate: yup.string().required('This is a required question')
  })
  .required()

export default function ModalCreateFund({
  isModalOpenAddMember,
  handleCancelAddMember,
  fnData
}) {
  const {
    reset,
    control,
    setValue,
    setError,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  })

  const [endDate, setEndDate] = useState(null)
  const [startDate, setStartDate] = useState(null)

  useEffect(() => {
    setValue('fundName', '')
    setValue('openDate', '')
    setValue('endDate', '')
  }, [isModalOpenAddMember])

  const onSubmit = async (body) => {
    let bodyFormat = {
      endDate: moment(body.endDate).format('YYYY-MM-DD'),
      fundName: body.fundName,
      openDate: moment(body.openDate).format('YYYY-MM-DD')
    }
    const resp = await createEjipFundAPI(bodyFormat)
    if (!resp) return
    if (resp.status) {
      SwalCustom({
        title: `Success!`,
        text: TXTSUCCESS,
        timer: 1500,
        showConfirmButton: false
      })
      fnData()
      setEndDate(null)
      handleCancelAddMember()
      reset()
    } else {
      Error_false(resp)
    }
  }

  return (
    <ModalCustom
      open={isModalOpenAddMember}
      centered
      onCancel={handleCancelAddMember}
    >
      <Form onSubmit={handleSubmit(onSubmit)} className="mt-2 row">
        <div className="col-12 ">
          <div className="fw-normal text-primary mb-3">Create New Fund</div>

          <div className="row mb-3">
            <div className="fw-normal col-12 ">
              <div className="p-1"> Name Fund</div>
              <Controller
                name={'fundName'}
                control={control}
                render={({ field: { onChange, value = '' } }) => (
                  <Form.Control value={value} onChange={onChange} />
                )}
              />
              {errors.fundName?.message && (
                <label className="small text-danger">
                  {errors.fundName.message}
                </label>
              )}
            </div>
          </div>
          <div className="row ">
            <div className="fw-normal col-6">
              <div className="p-1"> Fund Opening Date </div>{' '}
              <Controller
                name={'openDate'}
                control={control}
                render={({ field: { value = '', onChange } }) => (
                  <CustomDatePicker
                    dateFormat="dd/MM/yyyy"
                    maxDate={endDate ? new Date(endDate) : null}
                    showMonthYearPicker
                    id="picker-date-month-btn"
                    value={value}
                    onChange={(date) => {
                      onChange(date)
                      setStartDate(date)
                      setError('openDate', date)
                    }}
                  />
                )}
              />{' '}
              {errors.openDate?.message && (
                <label className="small text-danger">
                  {errors.openDate.message}
                </label>
              )}
            </div>
            <div className="fw-normal col-6 ">
              <div className="p-1"> Fund End Date</div>
              <Controller
                name={'endDate'}
                control={control}
                render={({ field: { value = '', onChange } }) => (
                  <CustomDatePicker
                    dateFormat="dd/MM/yyyy"
                    id="picker-date-month-btn"
                    value={value}
                    onChange={(date) => {
                      onChange(date)
                      setEndDate(date)
                      setError('endDate', date)
                    }}
                    minDate={startDate}
                  />
                )}
              />
              {errors.endDate?.message && (
                <label className="small text-danger">
                  {errors.endDate.message}
                </label>
              )}
            </div>

            <div className="col-12 mt-5 d-flex gap-3 justify-content-center">
              <Button
                variant="outline-primary"
                style={{
                  width: '130px'
                }}
                size="sm"
                className="rounded-3"
                onClick={handleCancelAddMember}
              >
                Cancel
              </Button>

              <Button
                className="btn btn-primary rounded-3"
                type="submit"
                style={{
                  width: '130px'
                }}
                size="sm"
              >
                Create
              </Button>
            </div>
          </div>
        </div>
      </Form>
    </ModalCustom>
  )
}
